// extracted by mini-css-extract-plugin
export var addViewLink = "_l-1";
export var availabilityIcon = "_l-16";
export var availabilitySelectionIcon = "_l-15";
export var backButton = "_l-2";
export var backIcon = "_l-z";
export var conversationCount = "_l-3";
export var dragHandle = "_l-5";
export var dropdown = "_l-e";
export var dropdownIcon = "_l-7";
export var dropdownOption = "_l-6";
export var dropdownTriangle = "_l-d";
export var expand = "_l-f";
export var folder = "_l-i";
export var folderItem = "_l-c";
export var icon = "_l-8";
export var iconRow = "_l-9";
export var image = "_l-a";
export var logo = "_l-b";
export var navContainer = "_l-h";
export var navigationFooter = "_l-g";
export var pageShell = "_l-0";
export var placeholderAvailable = "_l-11";
export var placeholderBox = "_l-14";
export var placeholderBusy = "_l-13";
export var placeholderUnavailable = "_l-12";
export var profile = "_l-k";
export var profileContainer = "_l-m";
export var profileDropdown = "_l-n";
export var profileImage = "_l-l";
export var profileMain = "_l-o";
export var profileSubtitle = "_l-q";
export var profileTitle = "_l-p";
export var reorderIcon = "_l-r";
export var sentLine = "_l-u";
export var settingsHeader = "_l-s";
export var sidenavTextColor = "_l-y";
export var spamLine = "_l-t";
export var subitemWithTag = "_l-4";
export var supportItems = "_l-j";
export var teamText = "_l-10";
export var viewLine = "_l-x";
export var viewLineButton = "_l-w";
export var viewLineButtons = "_l-v";